import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  invitationValidationSuccessful: {},
  companyInfo: {},
  clientInfo: {},
  currentStep: 1,
  visitedStepsCnt: 0,
  filledStepsCnt: 0,
  industries: [],
  regulations: [],
  regions: [],
  amountOfEmployees: [],
  companySuggestions: [],
  cybersecurityKnowhowOptions: [],
  loading: {},
  loadingErrors: {},
  recaptchaToken: null,
  invitationValidationRecaptchaToken: null,
  registrationInProgress: false,
  emailVerificationSent: false,
  clientAvatar: null,
  isUserPoolExist: null,
  whiteLabeling: null,
  registrationUserEmail: '',
};

export default {
  state,
  getters,
  mutations,
  actions,
};
